import { HelpIcon } from '@treams/treams-icons';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

const Container = styled(Flex)`
	background: ${(props) => props.theme.colors.lightBlueLight};
	color: ${(props) => props.theme.colors.slateBlue};
	border-radius: 20px;
	min-height: 40px;

	svg {
		display: block;

		path {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}

	&:hover {
		background: ${(props) => props.theme.colors.lightBlue};
	}
`;

export default function HelpLink(props: { id: string }) {
	const { t } = useTranslation();

	return (
		<a href={t(`${props.id}.link`)} target="_blank" rel="noreferrer">
			<Container p={2} alignItems="center">
				<Box flexGrow={0} flexShrink={0} mr={2}>
					<HelpIcon />
				</Box>
				<Box flexShrink={1} flexGrow={1}>
					{t(`${props.id}.text`)}
				</Box>
			</Container>
		</a>
	);
}
